import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/hsr/";

export default class HSRApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getHSRs(params) {
    return await request.post(`${rootRoute}getHSRs`, {
      filter: params,
      parameters: {},
    });
  }
  async getHSR(id) {
    return await request.post(`${rootRoute}getHSRs`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createHSR(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createHSR`, { data });
  }
  async deleteHSR(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteHSR`, { data });
  }
  async editHSR(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateHSR`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importHSR`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getHSRimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportHSR`, {
      filter: filter,
      format: format
    });
  }
}
